var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockSectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#FEFEFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 16C24.98 16 16 24.98 16 36C16 47.02 24.98 56 36 56C47.02 56 56 47.02 56 36C56 24.98 47.02 16 36 16ZM44.7 43.14C44.42 43.62 43.92 43.88 43.4 43.88C43.14 43.88 42.88 43.82 42.64 43.66L36.44 39.96C34.9 39.04 33.76 37.02 33.76 35.24V27.04C33.76 26.22 34.44 25.54 35.26 25.54C36.08 25.54 36.76 26.22 36.76 27.04V35.24C36.76 35.96 37.36 37.02 37.98 37.38L44.18 41.08C44.9 41.5 45.14 42.42 44.7 43.14Z",
    fill: "#ED6E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockSectionIcon);
export default __webpack_public_path__ + "static/media/clock-section-icon.731f080027237d7e788e84f32dc545cc.svg";
export { ForwardRef as ReactComponent };